const availableIcons = new Set([
  "antenna",
  "antenna_lighted",
  "chimney",
  "chimney_lighted",
  "crane",
  "crane_lighted",
  "mast",
  "tower",
  "tower_lighted",
  "windturbine",
  "windturbine_lighted",
]);

/** Never construct an image URL for a structure variant that is not bundled. */
export function routeObstacleIconHref(src: unknown): string {
  const name = String(src ?? "")
    .trim()
    .toLowerCase()
    .split(/[\\/]/)
    .pop()!
    .replace(/\.(svg|png)$/i, "");
  const icon = availableIcons.has(name) ? name : name.endsWith("_lighted") ? "tower_lighted" : "tower";
  return `/assets/icon/${icon}.svg`;
}
